import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "./api";
import { useBT } from "./i18n";
import { Input } from "../components/ui/input";
import { Loader2, Star } from "lucide-react";

export const PriorityGate = ({ end, onAllowed }) => {
  const { t } = useBT();
  const [v, setV] = useState("");
  const [busy, setBusy] = useState(false);
  const [denied, setDenied] = useState(false);

  const check = async (e) => {
    e.preventDefault();
    setBusy(true);
    const isEmail = v.includes("@");
    try {
      const r = await api.post("/api/public/priority/check", isEmail ? { email: v } : { phone: v });
      r.data.allowed ? onAllowed() : setDenied(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={check} className="bg-white border rounded-xl p-6 max-w-md space-y-3" data-testid="priority-gate">
      <p className="flex items-center gap-2 font-medium"><Star size={16} className="fill-amber-400 text-amber-400" /> {t.gateTitle}</p>
      <p className="text-xs text-[#1d2b31]/60">{t.priorityOnly.replace("{date}", end)}</p>
      <Input required value={v} onChange={(e) => { setV(e.target.value); setDenied(false); }} placeholder={t.gatePh} data-testid="priority-gate-input" />
      {denied && <p className="text-xs text-red-600" data-testid="priority-gate-denied">{t.gateDenied.replace("{date}", end)}</p>}
      <button type="submit" disabled={busy} data-testid="priority-gate-submit"
        className="w-full inline-flex justify-center items-center gap-2 bg-[#15262d] text-white text-xs uppercase tracking-[0.2em] px-6 py-3 rounded-sm hover:bg-[#b09873] transition-colors disabled:opacity-60">
        {busy && <Loader2 size={14} className="animate-spin" />} {t.gateBtn}
      </button>
    </form>
  );
};
